var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 12H20V14H18C16.62 14 15.26 13.65 14 13C11.5 14.3 8.5 14.3 6 13C4.74 13.65 3.37 14 2 14H0V12H2C3.39 12 4.78 11.53 6 10.67C8.44 12.38 11.56 12.38 14 10.67C15.22 11.53 16.61 12 18 12ZM18 18H20V20H18C16.62 20 15.26 19.65 14 19C11.5 20.3 8.5 20.3 6 19C4.74 19.65 3.37 20 2 20H0V18H2C3.39 18 4.78 17.53 6 16.67C8.44 18.38 11.56 18.38 14 16.67C15.22 17.53 16.61 18 18 18ZM5 0L1 4H4V9H6V4H9M15 0L11 4H14V9H16V4H19",
    fill: "#286795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterLevel);
export default __webpack_public_path__ + "static/media/water-level.221e31469f551e851bf2632f6629c72f.svg";
export { ForwardRef as ReactComponent };